import type * as ents from '@attain-apps/entities'
import type * as chartJs from 'chart.js'

/**
 * Get {@link ents.core.display.chart.data.Point} from chart data based on
 * dataset index and index from active elements
 */
export function getPointByIndex(
  data: ents.core.display.chart.data.Of<ents.core.display.chart.Type.Line>,
  elements: chartJs.ActiveElement[],
  isStacked = false,
): ents.core.display.chart.data.Point | undefined {
  // REVIEW: What should happen if there are more than one clicked element (eg.
  // if two points are on same coordinates)
  const elementDatasetIndex: number | undefined = elements[0]?.datasetIndex
  const elementIndex: number | undefined = elements[0]?.index
  if (!isStacked) {
    return elementDatasetIndex !== undefined && elementIndex !== undefined
      ? data.values?.[elementDatasetIndex]?.points?.[elementIndex]
      : undefined
  }

  const labels = Array.from(
    new Set(
      data?.values?.flatMap(
        value => value.points?.map(point => point.x ?? 0) ?? [],
      ) ?? [],
    ),
  )

  const pointMatrix: ents.core.display.chart.data.Point[][] = labels.map(
    x =>
      data?.values
        ?.map(({ points }) => points?.find(p => p.x === x))
        .filter(val => val !== undefined) ?? [],
  )
  // Get values for this X label (i.e. row in matrix)
  const row = pointMatrix[elementIndex] ?? []

  // Sort descending by value
  const sortedPoints = row.sort((a, b) => (b.y ?? 0) - (a.y ?? 0))

  const entry = sortedPoints[elementDatasetIndex]

  return entry
}
